module.exports = __webpack_public_path__ + "static/liva-convert-detail-two-370b93ab0f6b91fec0257dd481346edf.png";